import { Link } from "react-router-dom";
import { useExample } from "./useExample";

export const Example = () => {
  const { error, isLoading, posts } = useExample();
  return (
    <div>
      <Link to="/login">Ir Para Login</Link>
      {isLoading && <div>Carregando...</div>}
      {error && <div>{error}</div>}
      <ul>
        {posts.map((post) => (
          <li key={post.id}>{post.title}</li>
        ))}
      </ul>
    </div>
  );
};
